import React from "react";
import styled from "styled-components";
import theme from "../../../../assets/theme";
import { Modal } from "@material-ui/core";
import moment from "moment";

const EsLgnerLogs = ({ modal, setModal }) => {
  const formatToIST = (utcDateString) => {
    if (!utcDateString || typeof utcDateString !== "string") {
      throw new Error("Invalid or missing UTC date string");
    }

    const date = new Date(utcDateString);
    if (isNaN(date.getTime())) {
      throw new Error("Invalid date format");
    }

    const istOffsetMs = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(date.getTime() + istOffsetMs);

    const day = String(istDate.getUTCDate()).padStart(2, "0");
    const month = String(istDate.getUTCMonth() + 1).padStart(2, "0");
    const year = istDate.getUTCFullYear();
    const hours = String(istDate.getUTCHours()).padStart(2, "0");
    const minutes = String(istDate.getUTCMinutes()).padStart(2, "0");
    const seconds = String(istDate.getUTCSeconds()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <Modal
      open={modal?.state}
      onClose={() => setModal({ state: false })}
      disableRestoreFocus
    >
      <Container>
        <LogCard>
          <Header>
            <div>Name</div>
            <div>Status</div>
            <div>Logs</div>
          </Header>

          <LogEntry>
            <Name>{modal.name}</Name>

            <StatusContainer>
              <StatusBadge
                color={
                  modal.status === "Failed"
                    ? "#d91b1b"
                    : modal?.status === "Initiated"
                    ? "#d97706"
                    : modal?.status === "Completed"
                    ? "#00838c"
                    : "#155724"
                }
              >
                {modal.status}
              </StatusBadge>
              <Span>{modal?.message}</Span>
              {modal?.signedDate ? (
                <DateTime>{formatToIST(modal.signedDate)}</DateTime>
              ) : null}
            </StatusContainer>

            <LogsContainer>
              {modal?.timeLineData.map((log, index) => (
                <LogItem key={index}>
                  <LogText>
                    {moment(log, "YYYY-MM-DD HH:mm:ss").format(
                      "DD/MM/YYYY hh:mm A"
                    )}
                  </LogText>
                </LogItem>
              ))}
            </LogsContainer>
          </LogEntry>
        </LogCard>
      </Container>
    </Modal>
  );
};

export default EsLgnerLogs;


const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const LogCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
  border-radius: 18px;
`;

const Header = styled.div`
  display: grid;
  grid-template-columns: 200px 150px 1fr;
  gap: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #e9ecef;
  font-weight: 600;
  font-family: ${theme.fonts.primaryFontSemiBold};
  color: #293461;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 10px;
    text-align: center;
  }
`;

const LogEntry = styled.div`
  display: grid;
  grid-template-columns: 200px 150px 1fr;
  gap: 20px;
  align-items: center;
  margin-top: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 15px;
    text-align: center;
  }
`;

const Name = styled.div`
  font-weight: 600;
  color: #2c3e50;
  font-size: 16px;
`;

const StatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const StatusBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background-color: ${({ color }) => (color ? color : "#d4edda")};
  color: #ffffff;
  font-family: ${theme.fonts.primaryFontSemiBold};
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  width: fit-content;

  @media (max-width: 768px) {
    margin: 0 auto;
  }

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background-color: #ffffff;
    border-radius: 50%;
  }
`;

const DateTime = styled.div`
  font-size: 11px;
  color: #293461;
  margin-top: 2px;
  font-family: ${theme.fonts.primaryFontSemiBold};
`;

const LogsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 200px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

const LogItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background-color: #e3f2fd;
  border-radius: 8px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #bbdefb;
  }

  &::before {
    content: "";
    width: 6px;
    height: 6px;
    background-color: #1976d2;
    border-radius: 50%;
    flex-shrink: 0;
  }
`;

const LogText = styled.span`
  font-size: 13px;
  color: #1565c0;
  font-weight: 500;
`;

const Span = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  color: #293461;
`